import { emptyArray } from 'ui-components/default-props/empty';

import type { SuppliesState } from './supplies.types';
import type { RootState } from 'store/root-state';

export const selectProducts = (state: SuppliesState) => state.products ?? emptyArray;

export const selectIsLoading = (state: SuppliesState) => state.isLoading ?? false;

export const selectHasLoaded = (state: SuppliesState) => state.hasLoaded ?? false;

export const selectError = (state: SuppliesState) => state.error ?? null;

export const selectSuppliesProducts = (state: RootState) => selectProducts(state.supplies);
export const selectSuppliesIsLoading = (state: RootState) => selectIsLoading(state.supplies);
export const selectSuppliesHasLoaded = (state: RootState) => selectHasLoaded(state.supplies);
export const selectSuppliesError = (state: RootState) => selectError(state.supplies);
